export default __webpack_public_path__ + "static/media/img6.b69a88ce.svg";